import React from 'react';
import clsx from 'clsx';

import { statusLabels } from '../../constants/statuses';

import './_styles.scss';

export function StatusCell({ status, inDropdown = false, labelClassName = '', labelText = '' }) {
  const lowerCaseStatus = status ? `label-${status.toLowerCase()}` : '';
  const cellText = status ? statusLabels[status.toLowerCase()] : labelText;
  const children = (
    <div className="status-cell__wrapper ellipsis">
      <span className={clsx(lowerCaseStatus, labelClassName)} />
      <span className="status-cell__text ellipsis">{cellText}</span>
    </div>
  );

  return inDropdown ? children : <div className="status-cell">{children}</div>;
}
